
export default function SocialsHero() {
  const socialIcons = [
    { icon: 'fab fa-instagram', color: 'from-orange-400 to-pink-500', delay: '0s', top: '15%', left: '8%' },
    { icon: 'fab fa-tiktok', color: 'from-gray-700 to-gray-900', delay: '0.5s', top: '20%', right: '10%' },
    { icon: 'fab fa-facebook', color: 'from-sky-500 to-sky-700', delay: '1s', bottom: '25%', left: '6%' },
    { icon: 'fab fa-youtube', color: 'from-red-500 to-red-700', delay: '1.5s', bottom: '20%', right: '8%' },
    { icon: 'fab fa-pinterest', color: 'from-red-400 to-rose-600', delay: '2s', top: '50%', left: '3%' },
    { icon: 'fab fa-whatsapp', color: 'from-green-400 to-green-600', delay: '2.5s', top: '45%', right: '4%' },
  ];

  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-gray-950">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/361f9067a4959b568130c76a90187790.jpg)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950/60 via-gray-950/40 to-gray-950/80" />

      {/* Floating social icons */}
      {socialIcons.map((s, i) => (
        <div
          key={i}
          className="absolute hidden lg:flex"
          style={{
            top: s.top,
            left: s.left,
            right: s.right,
            bottom: s.bottom,
            animation: `float 4s ease-in-out infinite`,
            animationDelay: s.delay,
          }}
        >
          <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${s.color} flex items-center justify-center shadow-2xl opacity-70`}>
            <i className={`${s.icon} text-white text-2xl`}></i>
          </div>
        </div>
      ))}

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-14px) rotate(4deg); }
        }
      `}</style>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center text-white">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-sm font-medium px-5 py-2 rounded-full mb-8">
          <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse"></span>
          Follow our journey
        </div>

        <h1 className="text-5xl md:text-7xl font-extrabold mb-6 leading-tight tracking-tight">
          Stay Connected<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-300">
            With Brushour
          </span>
        </h1>

        <p className="text-lg md:text-xl text-white/70 mb-10 max-w-2xl mx-auto leading-relaxed">
          Follow us for daily transformations, painting tips, behind-the-scenes content, and exclusive offers across all our social channels.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="#platforms"
            className="bg-gradient-to-r from-orange-500 to-amber-500 text-white px-8 py-4 rounded-xl font-semibold hover:from-orange-600 hover:to-amber-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-orange-500/30"
          >
            Explore Our Channels
          </a>
          <a
            href="https://www.instagram.com/brushour_"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-xl font-semibold hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/20"
          >
            <i className="fab fa-instagram mr-2"></i>
            Follow on Instagram
          </a>
        </div>

        {/* Quick stats */}
        <div className="flex flex-wrap items-center justify-center gap-10 mt-16 pt-10 border-t border-white/10">
          {[
            { label: 'Instagram', value: '5K+', icon: 'fab fa-instagram' },
            { label: 'TikTok', value: 'Growing', icon: 'fab fa-tiktok' },
            { label: 'Facebook', value: '3.2K+', icon: 'fab fa-facebook' },
            { label: 'YouTube', value: '1.8K+', icon: 'fab fa-youtube' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <i className={`${stat.icon} text-orange-400 text-xl mb-1 block`}></i>
              <div className="text-2xl font-bold">{stat.value}</div>
              <div className="text-xs text-white/50 uppercase tracking-widest">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
